export default function translate(i18n, propriete) {
  if (propriete === 'dispositifId') return i18n.t('detailEmplacement.popupDeplacerDispositif.errors.dispositifId');
  if (propriete === 'emplacementId') return i18n.t('detailEmplacement.popupDeplacerDispositif.errors.emplacementId');
  return propriete;
}
